"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineCellStylesForExpandableTable = exports.COLUMN_IDS = void 0;
var css_1 = require("@emotion/css");
exports.COLUMN_IDS = {
    expand: 'expand',
    select: 'select',
};
var determineCellStylesForExpandableTable = function (columnIndex, rowDepth) {
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), columnIndex === 1 ? '&&& { padding-left: calc(var(--table-inner-horizontal-padding) * ' + (rowDepth + 1) + ')}' : '', columnIndex === 0 ? '&&& { padding: 0px; vertical-align: middle; }' : '');
};
exports.determineCellStylesForExpandableTable = determineCellStylesForExpandableTable;
var templateObject_1;
